import React, { useState } from 'react';
import './App.css';
import ReCAPTCHA from "react-google-recaptcha";

const Contact = () => {
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const onChange = (value) => {
    console.log("Captcha value:", value);
    setCaptchaVerified(true); 
  };

  return (
    <div className="page-fade-in">
      <div className="container" style={{ padding: '6rem 0', maxWidth: '800px' }}>
        
        <h1 style={{ fontSize: '3.5rem', fontWeight: '800', marginBottom: '1rem' }}>Get in touch.</h1>
        <p style={{ fontSize: '1.2rem', color: '#a1a1a1', marginBottom: '3rem' }}>
          Fill out the form below and our team will get back to you within 24 hours.
        </p>

        <form className="contact-form">
          {/* Row 1 */}
          <div className="form-row">
            <div className="form-group">
              <label>First Name <span className="required">*</span></label>
              <input type="text" placeholder="Adam" required />
            </div>
            <div className="form-group">
              <label>Last Name</label>
              <input type="text" placeholder="Smith" />
            </div>
          </div>

          {/* Row 2 */}
          <div className="form-row">
            <div className="form-group">
              <label>Email <span className="required">*</span></label>
              <input type="email" placeholder="adamsmith@company.com" required />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input type="tel" placeholder="(555) 123-4567" />
            </div>
          </div>

          {/* Row 3 */}
          <div className="form-group">
            <label>Company</label>
            <input type="text" placeholder="Exia Group" />
          </div>

          {/* Row 4 */}
          <div className="form-group">
            <label>Subject <span className="required">*</span></label>
            <input type="text" placeholder="Project Inquiry" required />
          </div>

          {/* Row 5 */}
          <div className="form-group">
            <label>Message <span className="required">*</span></label>
            <textarea placeholder="How can we help you? What are your needs?" rows="6" required></textarea>
          </div>

          {/* CAPTCHA SECTION */}
          <div style={{ margin: '2rem 0' }}>
            <ReCAPTCHA
              sitekey="6LdBQ1QsAAAAAHjtBjiQbUBDaLptY4AxuJ7vaHNO"
              onChange={onChange}
              theme="light"
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary" 
            disabled={!captchaVerified}
            style={{ 
              width: '100%', 
              fontSize: '1.1rem',
              opacity: captchaVerified ? 1 : 0.5, 
              cursor: captchaVerified ? 'pointer' : 'not-allowed'
            }}
          >
            Submit
          </button>

        </form>
      </div>
    </div>
  );
};

export default Contact;